import React from "react";
import { toast } from "react-toastify";

import EntityForm from "./components/EntityForm";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";

import { useAddEntityMutation } from "store/services/entityApi";
import { useNavigate } from "react-router-dom";

const EntityCreateScreen = () => {
  const breadcrumbs = [
    { title: "Entities", path: "/app/crm/entity/list" },
    { title: "New Entity" },
  ];

  const navigate = useNavigate();

  // RTK Query
  const [addEntity, { isLoading: creatingEntity }] = useAddEntityMutation();

  // methods
  const handleCreateEntity = async (data) => {
    try {
      const entity = await addEntity(data).unwrap();
      toast.success("Entity successfully added!");
      navigate(`/app/crm/entity/${entity?._id}/detail`);
    } catch (err) {
      toast.error(err?.data?.message ?? err?.message ?? "Couldn't add Entity!");
    }
  };

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingEntity}>
      <BreadcrumbLayout.Paper>
        <EntityForm isBusy={creatingEntity} onSubmit={handleCreateEntity} />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default EntityCreateScreen;
